import { Component } from '@angular/core';
import { GenericTable, GenericTableAction, GenericTableColumn } from '../../../../models/GenericCRUD/GenericTable';
import { GenericForm, GenericFormField } from '../../../../models/GenericCRUD/GenericForm';
import { Paginator } from '../../../../models/Paginator';
import { GenericCRUD } from '../../../../models/GenericCRUD/GenericCRUD';
import { PriceList } from '../../../../models/PriceList';
import { GenericCrudComponent } from "../../../../shared/components/generic-crud/generic-crud.component";
import { BreadcrumbService } from '../../../../core/services/breadcrumb/breadcrumb.service';

@Component({
  selector: 'app-price-list-configuration',
  standalone: true,
  imports: [
    GenericCrudComponent
  ],
  templateUrl: './price-list-configuration.component.html',
  styleUrl: './price-list-configuration.component.css'
})
export class PriceListConfigurationComponent {

  constructor(private breadcrumbService: BreadcrumbService) {
    // this.breadcrumbService.setBreadcrumb({
    //   display_name: 'Configuración',
    //   url: '/dashboard/configuracion',
    //   items: []
    // })
  }

  tableColumns: GenericTableColumn[] = [
    { name: 'ID', active: false, type: 'text', key: 'id', sort: true },
    { name: 'Concepto', active: true, type: 'text', key: 'concept', sort: true },
    { name: 'Fecha Creación', active: false, type: 'date', key: 'created_at', sort: true, format: 'dd/MM/yyyy hh:mm:ss' },
    { name: 'Fecha Modificación', active: false, type: 'date', key: 'updated_at', sort: true, format: 'dd/MM/yyyy hh:mm:ss' },
  ];

  formFields: GenericFormField[] = [
    { name: 'concept', type: 'text', label: 'Concepto', validations: 'required', colspan:2 },
  ];

  formFieldsEdit: GenericFormField[] = [
    { name: 'concept', type: 'text', label: 'Concepto', validations: 'required', colspan:2 },
  ];

  form: GenericForm = {
    successTitle: 'Creación correcta',
    errorTitle: 'Error en la creación',
    method: 'POST',
    fields: this.formFields,
    name: 'tarifa',
    createButtonTitle: 'Nueva Tarifa',
    cols: 2,
    createApiSlug: '/config/price-list/store',
    formTitle: 'Crear Tarifa',
    formButtonTitle: 'Crear Tarifa',
    width: '2xl',
  }

  tableActions: GenericTableAction[] = [
    {
      name: 'Editar',
      key: 'edit',
      form: {
        method: 'PUT',
        successTitle: 'Edición correcta',
        errorTitle: 'Error en la edición',
        fields: this.formFieldsEdit,
        name: 'tarifa',
        createButtonTitle: '',
        cols: 2,
        originalUpdateApiSlug: '/config/price-list/update/{{id}}',
        createApiSlug: '',
        updateApiSlug: '',
        originalFormTitle: 'Editar {{concept}}',
        formTitle: '',
        formButtonTitle: 'Editar',
        width: '2xl',
      },
      completeForm: true,
      replaceAllRowOnResponse: true,
      icon: '<svg xmlns="http://www.w3.org/2000/svg" class="w-4 text-dark" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M4 20h4l10.5 -10.5a2.828 2.828 0 1 0 -4 -4l-10.5 10.5v4" /><path d="M13.5 6.5l4 4" /><path d="M16 19h6" /></svg>',
      confirmation: false,
    },
    {
      name: 'Eliminar',
      key: 'delete',
      method: 'DELETE',
      icon: '<svg xmlns="http://www.w3.org/2000/svg" class="w-4 text-primary" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M4 7l16 0" /><path d="M10 11l0 6" /><path d="M14 11l0 6" /><path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12" /><path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3" /></svg>',
      confirmation: true,
      questionText: '¿Desea eliminar la tarifa?',
      deleteRowOnResponse: true,
      actionSlug: '/config/price-list/delete/{{id}}',
    }
  ]

  table: GenericTable<Paginator<PriceList>> = {
    columns: this.tableColumns,
    items: [],
    type: 'generic',
    loadItemsSlug: '/config/price-list/index',
    paginate: true,
    name: 'tarifas',
    actions: this.tableActions
  };

  genericCRUD: GenericCRUD<Paginator<PriceList>> = {
    genericForm: this.form,
    genericTable: this.table,
    useModalForm: true
  }
}
